import type {
  AreaGroupId,
  IndoorOutdoor,
  PriceType,
  RegionId,
  StayTime,
  Weekday,
} from "../data/schema";
import { areaGroups as areaGroupDefinitions, regions as regionDefinitions } from "../data/regions";

export const regionLabels = Object.fromEntries(
  regionDefinitions.map((region) => [region.id, region.shortName]),
) as Record<RegionId, string>;

export const regions = regionDefinitions.map((region) => region.id);

export const areaGroupLabels = Object.fromEntries(
  areaGroupDefinitions.map((areaGroup) => [areaGroup.id, areaGroup.name]),
) as Record<AreaGroupId, string>;

export const weekdayLabels: Record<Weekday, string> = {
  monday: "월",
  tuesday: "화",
  wednesday: "수",
  thursday: "목",
  friday: "금",
  saturday: "토",
  sunday: "일",
};

export const weekdayNames: Record<Weekday, string> = {
  monday: "월요일",
  tuesday: "화요일",
  wednesday: "수요일",
  thursday: "목요일",
  friday: "금요일",
  saturday: "토요일",
  sunday: "일요일",
};

export const weekdays = Object.keys(weekdayLabels) as Weekday[];

export const indoorOutdoorLabels: Record<IndoorOutdoor, string> = {
  indoor: "실내",
  outdoor: "야외",
  mixed: "실내외",
};

export const priceLabels: Record<PriceType, string> = {
  free: "무료",
  paid: "유료",
  mixed: "부분유료",
};

export const stayTimeLabels: Record<StayTime, string> = {
  "under-1h": "1시간 미만",
  "1-2h": "1-2시간",
  "2-4h": "2-4시간",
  "half-day": "반나절",
};

export const stayTimes = Object.keys(stayTimeLabels) as StayTime[];
